import { render, staticRenderFns } from "./TakePhotoDialog.vue?vue&type=template&id=63db274d"
import script from "./takePhotoDialog.js?vue&type=script&lang=js&external"
export * from "./takePhotoDialog.js?vue&type=script&lang=js&external"
import style0 from "./takePhotoDialog.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63db274d')) {
      api.createRecord('63db274d', component.options)
    } else {
      api.reload('63db274d', component.options)
    }
    module.hot.accept("./TakePhotoDialog.vue?vue&type=template&id=63db274d", function () {
      api.rerender('63db274d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/take-photo-dialog/TakePhotoDialog.vue"
export default component.exports